import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    date: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, phone, email, service, date, message } = formData;

    const text = `🩺 *New Physiotherapy Appointment - RV Physio Therapy*%0A%0A` +
      `👤 *Name:* ${name}%0A` +
      `📞 *Phone:* ${phone}%0A` +
      `✉️ *Email:* ${email}%0A` +
      `🏥 *Service:* ${service}%0A` +
      `📅 *Preferred Date:* ${date}%0A` +
      `📝 *Message/Symptoms:* ${message || 'N/A'}%0A%0A` +
      `Sent from RV Physio Therapy Website`;

    const whatsappUrl = `https://web.whatsapp.com/send?phone=917048944596&text=${text}`;
    window.open(whatsappUrl, '_blank');
  };

  const contactCards = [
    {
      icon: <Phone size={20} />,
      title: 'Phone',
      content: <a href="tel:+917048944596">+91 70489 44596</a>,
    },
    {
      icon: <Mail size={20} />,
      title: 'Email',
      content: <a href="mailto:contact@rvtechnologies.net.in">contact@rvtechnologies.net.in</a>,
    },
    {
      icon: <MapPin size={20} />,
      title: 'Address',
      content: <p>Tower T3, 7th Floor, 739, Sector Techzone-IV, Greater Noida (West), GautamBudh Nagar, Uttar Pradesh 201306</p>,
    },
    {
      icon: <Clock size={20} />,
      title: 'Working Hours',
      content: <p>Mon - Sat: 9:00 AM - 8:00 PM<br />Sunday: Emergency Only</p>,
    },
  ];

  return (
    <div className="contact-page">
      <section className="section">
        <div className="contact-grid">
          <div className="contact-info">
            <h1>Book Your Physiotherapy Session</h1>
            <p>Ready to start your recovery journey? Reach out to us and our expert physiotherapists will guide you through personalized treatment plans.</p>

            <div className="contact-cards">
              {contactCards.map((card, i) => (
                <div className="contact-card" key={i}>
                  <div className="contact-icon">{card.icon}</div>
                  <div>
                    <h4>{card.title}</h4>
                    {card.content}
                  </div>
                </div>
              ))}
            </div>

            {/* SEO Local Business Schema */}
            <div style={{display: 'none'}} itemScope itemType="https://schema.org/LocalBusiness">
              <span itemProp="name">RV Physio Therapy</span>
              <span itemProp="telephone">+917048944596</span>
              <span itemProp="email">contact@rvtechnologies.net.in</span>
              <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                <span itemProp="streetAddress">Tower T3, 7th Floor, 739, Sector Techzone-IV</span>
                <span itemProp="addressLocality">Greater Noida (West)</span>
                <span itemProp="addressRegion">Uttar Pradesh</span>
                <span itemProp="postalCode">201306</span>
              </div>
            </div>
          </div>

          <div className="contact-form">
            <h3>Book an Appointment</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Full Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="+91 98765 43210"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="your@email.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Select Treatment</label>
                  <select name="service" value={formData.service} onChange={handleChange} required>
                    <option value="">Choose a treatment</option>
                    <option value="Back Pain Treatment">Back Pain Treatment</option>
                    <option value="Sports Injury Rehab">Sports Injury Rehab</option>
                    <option value="Stroke Rehabilitation">Stroke Rehabilitation</option>
                    <option value="Joint Pain Therapy">Joint Pain Therapy</option>
                    <option value="Post-Surgery Rehab">Post-Surgery Rehab</option>
                    <option value="Electrotherapy">Electrotherapy</option>
                    <option value="Posture Correction">Posture Correction</option>
                    <option value="Pediatric Physiotherapy">Pediatric Physiotherapy</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label>Preferred Date</label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  min={new Date().toISOString().split('T')[0]}
                  required
                />
              </div>
              <div className="form-group">
                <label>Symptoms / Message</label>
                <textarea
                  name="message"
                  placeholder="Describe your pain, symptoms, or any special requirements..."
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                />
              </div>
              <button type="submit" className="form-submit">
                <Send size={18} /> Book via WhatsApp
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
